import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Action, ActionStatus } from '@/application/types';
import { showError } from '@/application/snackbar/service';
import { GetProductIdentificationsByProjectNumberQuery, ProductIdentification } from '@/domain/product-search/types';
import { Project } from '../../types';

const projectSearchState = namespace('projectSearch');
const productSearchState = namespace('productSearch');

@Component
export default class SearchResults extends Vue {

  @projectSearchState.State
  readonly projects!: Project[];

  @projectSearchState.State
  readonly getProjectsByBaseProjectNumberStatus!: ActionStatus;

  @projectSearchState.State
  readonly lastSearchTerm!: string;

  @projectSearchState.State
  readonly hasSearchBeenTriggered!: boolean;

  @projectSearchState.State
  readonly hasSearchResultedIn0Results!: boolean;

  @productSearchState.Action
  readonly getProductIdentificationsByProjectNumber!: Action<GetProductIdentificationsByProjectNumberQuery>;

  @productSearchState.State
  readonly productIdentifications!: ProductIdentification[];

  get isLoading(): boolean {
    return this.getProjectsByBaseProjectNumberStatus === ActionStatus.InProgress;
  }

  get isListShown(): boolean {
    return !this.isLoading && this.projects.length > 0;
  }

  get isEmptyStateShown(): boolean {
    return !this.isLoading && !this.hasSearchBeenTriggered;
  }

  get isNoResultsShown(): boolean {
    return !this.isLoading && this.hasSearchBeenTriggered && this.hasSearchResultedIn0Results;
  }

  projectClicked(project: Project): void {
    const query: GetProductIdentificationsByProjectNumberQuery = {
      projectNumber: project.projectNumber,
    };
    this.getProductIdentificationsByProjectNumber(query)
      .then(() => {
        if (this.productIdentifications.length === 1) {
          const singleProductIdentification = this.productIdentifications[0];
          if (singleProductIdentification.id !== this.$route.params.id) {
            this.$router.push({ name: 'product-search/product-details', params: { id: singleProductIdentification.id } });
          }
        } else if (this.$route.name !== 'product-search/search') {
          this.$router.push({ name: 'product-search/search' });
        }
      })
      .catch((error) => {
        const message = error.response?.data.message || 'Die Suche ist fehlgeschlagen';
        showError({ message });
      });
  }

  productCountText(project: Project): string {
    if (project.activeProductCount === 0) {
      return 'Enthält keine aktiven Produkte';
    }

    return project.activeProductCount > 1
      ? `Enthält ${project.activeProductCount} aktive Produkte`
      : 'Enthält 1 aktives Produkt';
  }

}
